import { Directive } from '@angular/core';
import { WrapperV2ComponentDirective } from '@rd-lib/whitelabel/wrapper/wrapper-v2.component';
import { rcV2ComponentMap } from './component-map';

@Directive()
export abstract class RedeemCashV2WrapperComponentDirective extends WrapperV2ComponentDirective {
  componentMap(): { [key: string]: any } {
    return rcV2ComponentMap;
  }
}
